const projectsData = [
  {
    projectName: "Collabohub",
    detailOnCard:
      "CollaboHub is a comprehensive project management platform designed to streamline workflows and enhance collaboration. It simplifies task management, facilitates real-time communication, and provides insightful analytics for effective project planning and execution",
    description: "",
    did: [
      "Designed and developed Collabohub using MERN stack with secure authentication and JWT encryption.",
      "Integrated WebSocket’s for live updates and real-time communication.",
      "Incorporated drag-and-drop functionality to optimize task management and workflow efficiency.",
      "Utilized Redux for state management and data flow throughout the application.",
      "Implemented user-friendly interface with React components for seamless navigation.",
      "Employed Git for version control, enabling collaborative development.",
      "Utilized Socket.IO for real-time bidirectional event-based communication.",
      "Implemented robust error handling mechanisms for application stability.",
      "Deployed the application on cloud platforms like Heroku or AWS for accessibility and scalability.",
      "Utilized Redux DevTools for debugging and monitoring application state.",
    ],
    stack: [
      "MongoDB",
      "Express.js",
      "React",
      "Node.js",
      "WebSocket (Socket.IO)",
      "Redux",
      "JWT Authentication",
      "Git Version Control",
      "JavaScript (ES6+)",
      "HTML",
      "CSS",
      "Responsive Web Design Principles",
      "API Development",
    ],
    time: "02/2024 - 03/2024",
    contributor: [],
    projectLink: "https://collabo-hub-qwzu.vercel.app/",
    marketComparison: ["Trello", "Asana", "Basecamp"],
    uniqueness:
      "Unique in offering real-time communication and analytics alongside project management, distinguishing it from platforms like Trello, Asana, and Basecamp.",
  },
  {
    projectName: "EFIR",
    detailOnCard:
      "Developed EFIR with MongoDB, React, Express, and Node.js. Implemented token-based authentication and integrated generative AI, improving efficiency by 50%. Automated notifications and unique police IDs enhanced tracking accuracy. Designed interactive UI.",
    description: "",
    did: [
      "Developed EFIR, leveraging MERN stack alongside generative AI for efficient complaint handling.",
      "Implemented token-based authentication and authorization mechanisms for secure user access.",
      "Ensured data security through Base64 encryption and bcryptjs for robust confidentiality and integrity.",
      "Automated notifications based on geographical areas for swift and accountable response.",
      "Assigned unique IDs to police personnel for efficient complaint tracking by judiciary officials.",
      "Enabled prompt action by both police and judiciary, optimizing legal processes.",
      "Utilized generative AI for complaint summarization and categorization, enhancing resource allocation.",
      "Provided users with accessible legal advice via AI interaction, improving user engagement.",
      "Security measures include encryption for data at rest and during transmission, token-based authentication, input validation, and regular security audits to mitigate vulnerabilities.",
    ],
    stack: [
      "MongoDB",
      "React",
      "Express.js",
      "Node.js",
      "Generative AI",
      "Git Version Control",
      "Token-based Authentication",
      "Base64 Encryption",
      "bcryptjs",
      "Interactive UI Design",
    ],
    time: "03/2024 - 04/2024",
    contributor: [],
    projectLink: "https://efir-legal-ease-shubham6762.vercel.app/",
    marketComparison: [],
    uniqueness:
      "Unique in providing an advanced complaint management solution with token-based authentication, generative AI integration, and automated notifications, enhancing efficiency and security in complaint handling processes.",
  },

  {
    projectName: "MazeMasterminds",
    detailOnCard:
      "Dive into the world of mazes with our innovative Maze Solver web application. Built on the MERN stack, this application allows users to dynamically create mazes with customizable blockages or generate random mazes based on difficulty levels. Powered by BFS algorithms, our app efficiently finds and returns optimal paths, providing a seamless and interactive maze-solving experience.",
    description: "",
    did: [
      "Implemented Maze Solver project using React and TailwindCSS for responsive UI design.",
      "Integrated customizable grid system for generating mazes of varying sizes.",
      "Developed feature to introduce blockages dynamically, enhancing maze complexity.",
      "Utilized Breadth-First Search (BFS) algorithm for efficient maze-solving capabilities.",
      "Enhanced user experience with interactive controls for maze creation and customization.",
      "Achieved seamless responsiveness across devices through TailwindCSS.",
      "Empowered users with intuitive controls and visual feedback for maze navigation.",
      "Implemented algorithmic logic for maze solving, ensuring optimal pathfinding solutions.",
      "Provided users with flexibility to select difficulty levels, adjusting maze complexity.",
      "Combined React's component-based architecture with TailwindCSS for maintainable code.",
    ],
    stack: [
      "React",
      "TailwindCSS",
      "Breadth-First Search (BFS) Algorithm",
      "JavaScript (ES6+)",
      "HTML",
      "CSS",
      "Responsive Web Design Principles",
      "Dynamic Grid Generation",
      "UI/UX Design",
    ],
    time: "01/2024 - 01/2024",
    contributor: [],
    projectLink: "https://mazesolvershubham6762.netlify.app/",
    marketComparison: ["MazeEscape", "MazeGenius", "MazeSolver"],
    uniqueness:
      "Unique in providing customizable maze-solving capabilities, distinguishing it from competitors like MazeEscape, MazeGenius, and MazeSolver.",
  },
  {
    projectName: "Matrix Calculator",
    detailOnCard:
      "Experience precision and efficiency with our Matrix Calculator project. Developed in Python, it offers advanced functionalities including row echelon, inverse, determinant, rank, and eigenvalues computations. Custom algorithms ensure a 40% improvement in computational efficiency with 100% result accuracy. We've simplified complex operations, enhancing user experience for comprehensive solution analysis.",
    description: "",
    did: [
      "Developed and implemented Python matrix calculator with advanced functionalities for matrix operations.",
      "Implemented custom algorithms for accurate calculations without relying on external libraries, ensuring 100% accuracy.",
      "Enhanced user experience by simplifying complex matrix operations and facilitating comprehensive solution analysis.",
      "Utilized NumPy, SymPy, and IPython display's Latex for efficient matrix manipulation and elegant display of mathematical expressions.",
      "Leveraged NumPy's optimized array operations for high-performance computation.",
      "Integrated SymPy for symbolic mathematics, enabling precise computations and analysis of matrix properties.",
      "Utilized IPython display's Latex for rendering mathematical expressions in a visually appealing format.",
      "Provided interactive features using IPython for seamless user experience within Jupyter Notebook environment.",
      "Utilized advanced mathematical concepts to implement specialized algorithms for matrix operations.",
      "Implemented error handling mechanisms to ensure robustness in matrix calculation process.",
      "Enhanced code readability and maintainability through clear documentation and modular design.",
    ],
    stack: [
      "Python",
      "NumPy",
      "SymPy",
      "IPython",
      "Latex (IPython Display)",
      "Custom Algorithms for Matrix Operations",
      "Mathematical Concepts (Row Echelon, Inverse, Determinant, Rank, Eigenvalues)",
      "Error Handling Mechanisms",
      "Jupyter Notebook",
      "Mathematical Optimization Techniques",
      "Symbolic Mathematics",
      "Algorithmic Efficiency Techniques",
    ],
    time: "04/2023 - 06/2024",
    contributor: [],
    projectLink: "",
    marketComparison: ["Wolfram Alpha", "Matlab", "Octave"],
    uniqueness:
      "Unique in offering a specialized Matrix Calculator with advanced mathematical functionalities, distinguishing it from general-purpose calculators like Wolfram Alpha, Matlab, and Octave.",
  },
];

export default projectsData;
